import { render, staticRenderFns } from "./GetTancode.vue?vue&type=template&id=2e795d1d&scoped=true&"
import script from "./GetTancode.vue?vue&type=script&lang=js&"
export * from "./GetTancode.vue?vue&type=script&lang=js&"
import style0 from "./GetTancode.vue?vue&type=style&index=0&id=2e795d1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e795d1d",
  null
  
)

export default component.exports